import React from 'react';

import { Utils } from '@adobe/aem-react-editable-components';
import { useAuth } from 'context/Auth';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';
import { Route } from 'react-router-dom';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';
import { FachinteressentAccessDeniedModal } from 'components/FachinteressentAccessDeniedModal/FachinteressentAccessDeniedModal';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';

import { loginWithRedirect, logoutWithRedirect } from 'utils/AuthUtils';
import { isFachinteressent } from 'utils/InstallerUtils';
import { getFachinteressentAccessDenial } from 'utils/fachinteressentAccess';
import { getTenantId } from 'utils/tenantUtil';

export const PrivateRoute = (props) => {
  const { isAuthenticated, isLoading, isCIAM, isPublic } = useAuth();
  const {
    installer,
    error: installerError,
    hasInstallerResponse,
  } = useCurrentInstaller({
    skip: isPublic || isLoading || !isAuthenticated,
    suppressError: true,
  });
  const isEditor = Utils.isInEditor();
  if (isEditor || isPublic) {
    return <Route {...props} />;
  }
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!isAuthenticated) {
    loginWithRedirect(isCIAM);
    return null;
  }

  if (installerError) {
    return (
      <CustomModal
        isOpen
        title="Portal momentan nicht erreichbar"
        content={
          <div>
            Die Daten Ihrer Fachkraft konnten nicht geladen werden. Bitte versuchen Sie es später
            erneut.
          </div>
        }
        ctaButtons={
          <ActionButton
            title="Erneut versuchen"
            inverted
            onClick={() => window.location.reload()}
          />
        }
      />
    );
  }

  if (isCIAM && hasInstallerResponse && !installer) {
    return (
      <CustomModal
        isOpen
        title="Anmeldung fehlgeschlagen"
        content={
          <div>
            Dieses Fachkraft-Konto wurde gelöscht und kann nicht mehr verwendet werden. Bitte
            kontaktieren Sie Ihren Administrator und lassen Sie sich im Installateurs-Konto ein
            neues Zusatz-Konto anlegen.
          </div>
        }
        ctaButtons={<ActionButton title="OK" inverted onClick={() => logoutWithRedirect(isCIAM)} />}
      />
    );
  }

  if (isCIAM && installer && isFachinteressent(installer)) {
    const denial = getFachinteressentAccessDenial(installer, getTenantId());
    if (denial) {
      return <FachinteressentAccessDeniedModal />;
    }
  }

  return <Route {...props} />;
};
